export const getSchemaOrgReviews = ({ reviews }) => {
  const reviewList = [];

  reviews.forEach(review => {
    reviewList.push(
      JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'Review',
        reviewBody: review.review_body || '',
        itemReviewed: {
          '@type': 'Organization',
          name: 'Wooclap',
        },
        author: {
          '@context': 'http://schema.org',
          '@type': 'Person',
          name: `${review.reviewer_firstname || ''} ${
            review.reviewer_lastname || ''
          }`,
          givenName: review.reviewer_firstname || '',
          familyName: review.reviewer_lastname || '',
          jobTitle: review.reviewer_job_title || '',
        },
        name: review.review_name || '',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
        },
      })
    );
  });

  return reviewList;
};
